import * as t from "io-ts";
import {LocationBreadcrumbCodec} from "./location-breadcrumb";
import {LocationMetaCodec} from "./location-meta";

export const LocationContextCodec = t.intersection([
  t.type({
    entityId: t.string,
    entityType: t.string,
    entityName: t.string,
    tenantCode: t.string,
  }),
  t.partial({
    entityAttributes: t.record(t.string, t.unknown),
    companyId: t.string,
    companyName: t.string,
    location: LocationBreadcrumbCodec,
    meta: LocationMetaCodec,
    message: t.string,
  }),
]);

export const LocationContextArrayCodec = t.array(
  LocationContextCodec
);

export type LocationContext = t.TypeOf<typeof LocationContextCodec>;
